import { Box } from '@mui/material';
import PrimarySearchAppBar from "../components/PrimarySearchAppBar";
import { useAuth0 } from "@auth0/auth0-react";
import { ResultJSON } from '../components/ResultJSON';
import { FIPOKSurveys } from '../components/FIPOKSurveys';
import { Domains } from '../Utils';

export const SurveysPage = () => {

    const auth0Obj = useAuth0();
    const isAuthenticated = auth0Obj.isAuthenticated;

    return (
        <Box>
            <PrimarySearchAppBar />
                {!isAuthenticated && (
                    <Box>
                        A tartalom megtekintéséhez be kell jelentkeznie.
                        You are not authenticated. Log in to see the contents.

                    </Box>
                )}
                {isAuthenticated && (
                    <ResultJSON bucketBaseURL={Domains.gamesURL} code={`surveys`}>
                        <FIPOKSurveys />
                    </ResultJSON>
                )

                }
        </Box>
    );
};
